import React from "react";
import { Tabs } from "antd";

const MarketingFeatureTabUi = ({ tabId, setTabId }) => {
  return (
    <Tabs
      className="mx-2 text-base"
      popupClassName="mb-0"
      tabBarStyle={{
        marginBottom: 0,
      }}
      activeKey={tabId}
      defaultActiveKey={tabId}
      items={[
        { label: "Landing banners", key: "landing" },
        { label: "Category banners", key: "category" },
        { label: "Running Line banners", key: "runningLine" },
        {
          label: "Featured category products",
          key: "featuredCategoryProducts",
        },
        { label: "Promotion popups", key: "promotionPopups" },
      ]}
      onChange={(value) => {
        setTabId(value);
      }}
    />
  );
};

export default MarketingFeatureTabUi;
